import { render, staticRenderFns } from "./exchangeItem.vue?vue&type=template&id=9319f866&scoped=true&"
import script from "./exchangeItem.vue?vue&type=script&lang=js&"
export * from "./exchangeItem.vue?vue&type=script&lang=js&"
import style0 from "./exchangeItem.vue?vue&type=style&index=0&id=9319f866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9319f866",
  null
  
)

export default component.exports